import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmailCollectorPackageInformation } from 'osn-shared';

type JsMonth = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

@Pipe({
  name: 'emailCollectorFreeTrial',
  pure: false,
})
export class EmailCollectorFreeTrialPipe implements PipeTransform {
  private static readonly monthTranslationKeyRecord: Record<JsMonth, string> = {
    '0': 'Month_JAN',
    '1': 'Month_FEB',
    '2': 'Month_MAR',
    '3': 'Month_APR',
    '4': 'Month_MAY',
    '5': 'Month_JUN',
    '6': 'Month_JUL',
    '7': 'Month_AUG',
    '8': 'Month_SEP',
    '9': 'Month_OCT',
    '10': 'Month_NOV',
    '11': 'Month_DEC',
  };

  constructor(private readonly translateService: TranslateService) {}

  public transform(value: EmailCollectorPackageInformation): string {
    const date = new Date();
    date.setDate(date.getDate() + value.freeTrialDays);

    return this.translateService.instant(value.isEmergingMarket ? 'Free_Trial_Text_Emerging' : 'Free_Trial_Text', {
      month: this.translateService.instant(EmailCollectorFreeTrialPipe.monthTranslationKeyRecord[date.getMonth()]),
      date: date.getDate(),
      price: value.price,
      currency: value.currency,
    });
  }
}
